/// <amd-module name="VSS/Redux/Modules/Telemetry/TelemetryModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { monitorForTelemetry } from "VSS/Redux/Modules/Telemetry/TelemetrySaga";
import { ITelemetryModuleArgs } from "VSS/Redux/Modules/Telemetry/TelemetryContracts";

export function getTelemetryModule(area: string, serviceInstanceType?: string): ISagaModule<never> {
    const telemetryArgs : ITelemetryModuleArgs = {
        area,
        serviceInstanceType
    };

    return { id: `telemetry-${area}`, sagas: [{ saga: monitorForTelemetry, argument: telemetryArgs }] };
}